import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import services from '../../services';
import { toast } from 'react-toastify';
import { gmailQueuedMessage } from '../../utils/gmailQueued';
import Loading from '../../utils/Loading';
import { getEffectivePrivileges } from '../../utils/normalizeKey';
import Select from 'react-dropdown-select';
import { Tooltip } from 'react-tooltip';
import EditorComponent from '../Template/Editor';
import Dropdown from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Confirmation from '../../common/Confirmation';
import { mailReplySelectStyles } from '../../common/mailReplySelectStyles';
import { getLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';

const ComposeEmail = ({
    currentTaskId,
    replyDropdown,
    subject,
    selectedMail,
    setComposeStatus,
    setLoading,
    attachmentPaths,
    boardId,
    getTaskById,
    childTaskData,
    taskID,
    originalEmail,
    boardListId,
    setLabelAnchorEl,
    setIsSend,
    labelname,
    setLabelname,
    labelIds = [],
    setLabelIds

}) => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [compose, setCompose] = useState({
        sentTo: '',
        subject: '',
        body: '',
        parentTaskID: '',
        parentTaskStatus: '',
        sentBy: '',
        boardId: '',
        reminder: false,
        reminderDate: null,
    });
    const [gmailUsers, setGmailUsers] = useState([]);
    const [mailSource, setMailSource] = useState('gmail');
    const [webmailAccounts, setWebmailAccounts] = useState([]);
    const [templateselect, setTemplateselect] = useState('');
    const [template, setTemplate] = useState({
        templateData: '',
    });
    const [allTemp, setAllTemp] = useState([]);

    const userDataRaw = getLocalStorageItem('userData');
    const userDataParsed = typeof userDataRaw === 'string' ? (() => { try { return JSON.parse(userDataRaw); } catch { return null; } })() : userDataRaw;
    const userDataRef = useRef(userDataParsed);
    useEffect(() => { userDataRef.current = userDataParsed; }, [userDataParsed]);

    const [bodyManuallyEdited, setBodyManuallyEdited] = useState(false);
    const [editorKey, setEditorKey] = useState('compose-editor');
    const prevReplyDropdown = useRef(replyDropdown);
    const prevAllTempLength = useRef(allTemp?.length);
    const [showCc, setShowCc] = useState(false);
    const [showBcc, setShowBcc] = useState(false);
    const [draftStatus, setDraftStatus] = useState("");
    const [draftId, setDraftId] = useState(null);
    const [folder, setFolder] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState('');
    const [availableLanguages, setAvailableLanguages] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState('English');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showComposeReminderDropdown, setShowComposeReminderDropdown] = useState(false);
    const [showReminderDatePicker, setShowReminderDatePicker] = useState(false);
    const [reminderNote, setReminderNote] = useState('');
    const [myDayChecked, setMyDayChecked] = useState(true);
    const [deadlineChecked, setDeadlineChecked] = useState(true);
    const [showCalendar, setShowCalendar] = useState(false);
    const [childReminderApplied, setChildReminderApplied] = useState(false);
    const [noReminderNeeded, setNoReminderNeeded] = useState(false);
    const [errors, setErrors] = useState({});
    const memoizedPrevData = useMemo(() => ({ templateData: compose.body }), [compose.body]);
    const memoizedHandleEditorChange = useCallback((data) => {
        setCompose((prev) => {
            if (prev.body === data) return prev;
            return { ...prev, body: data };
        });
        setErrors((prev) => ({ ...prev, body: '' }));
    }, []);

    const handleDelete = () => {
        setComposeStatus(false);
        setLabelname([]);
        if (setLabelIds) setLabelIds([]);
    }

    const formatEpochToISO = (epochMillis) => {
        const date = new Date(epochMillis < 1e12 ? epochMillis * 1000 : epochMillis);
        return date.toISOString();
    };
 const formatDateForDisplay = (date) => {
        if (!date) return '';

        const inputDate = new Date(date);
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const targetDay = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
        const msPerDay = 1000 * 60 * 60 * 24;
        const daysDiff = Math.floor((targetDay - today) / msPerDay);
        const timeString = inputDate.toLocaleString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });

        if (daysDiff === 0) return `Today, ${timeString}`;
        if (daysDiff === 1) return `Tomorrow, ${timeString}`;
        if (daysDiff === 2) return `In two days, ${timeString}`;

        return inputDate.toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
    };
    const formatToLocalISO = (date) => {
        if (!date) return null;
        return formatEpochToISO(date.getTime());
    };


    const getFormattedDate = (dateOption) => {
        if (dateOption && typeof dateOption === 'object' && 'daysToAdd' in dateOption) {
            const date = new Date();
            date.setDate(date.getDate() + dateOption.daysToAdd);
            date.setHours(dateOption.time.hours, dateOption.time.minutes, 0, 0);
            return date;
        }
        return dateOption;
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validate = (noReminder) => {
        const newErrors = {};
        if (!compose.sentBy) newErrors.sentBy = 'From is required';
        if (!compose.sentTo) {
            newErrors.sentTo = 'To is required';
        }
        if (compose.cc && !emailRegex.test(compose.cc)) newErrors.cc = 'Enter a valid Cc email address';
        if (compose.bcc && !emailRegex.test(compose.bcc)) newErrors.bcc = 'Enter a valid Bcc email address';
        if (!compose.subject?.trim()) newErrors.subject = 'Subject is required';
        const bodyText = compose.body?.replace(/<[^>]*>/g, '').trim();
        if (!bodyText) newErrors.body = 'Message is required';
        const reminderHandled = noReminder || (compose.reminder && compose.reminderDate);
        if (!reminderHandled) newErrors.reminder = 'Please set a reminder or select "No reminder needed"';
        return newErrors;
    };

    const handleReminderSelection = (dateOption) => {
        const date = getFormattedDate(dateOption);
        const formatted = formatToLocalISO(date);
        setCompose((prev) => ({ ...prev, reminder: true, reminderDate: formatted }));
        setNoReminderNeeded(false);
        setErrors((prev) => ({ ...prev, reminder: '' }));
        setShowReminderDatePicker(false);
    };

    const clearReminder = () => {
        setCompose((prev) => ({ ...prev, reminder: false, reminderDate: null }));
        setShowComposeReminderDropdown(false);
        setShowReminderDatePicker(false);
        setReminderNote('');
        setMyDayChecked(true);
        setDeadlineChecked(true);
        setNoReminderNeeded(false);
    };

    useEffect(() => {
        let shouldRemount = false;
        if (!prevReplyDropdown.current && replyDropdown) {
            shouldRemount = true;
        }
        if (prevAllTempLength.current === 0 && allTemp?.length > 0) {
            shouldRemount = true;
        }
        if (shouldRemount) {
            setEditorKey('compose-editor-' + Date.now());
        }
        prevReplyDropdown.current = replyDropdown;
        prevAllTempLength.current = allTemp?.length;
    }, [replyDropdown, allTemp]);

    useEffect(() => {
        if (!selectedMail) return;
        const rawSentBy = selectedMail?.Email?.sentBy;
        const rawSentTo = selectedMail?.Email?.sentTo;
        const sentByEmail = rawSentBy?.match(/<([^>]+)>/)?.[1] || rawSentBy;
        const sentToEmail = rawSentTo?.match(/<([^>]+)>/)?.[1] || rawSentTo;

        setCompose((prev) => ({
            ...prev,
            parentTaskID: currentTaskId || selectedMail.id,
            parentTaskStatus: true,
            sentBy: '',
            boardListId: boardListId || selectedMail.boardListId,
            sentTo: '',
            attachmentPaths: [],
            body: '',
            subject: '',
            boardId: boardId,
        }));
    }, [selectedMail]);

    useEffect(() => {
        setChildReminderApplied(false);
    }, [selectedMail?.id, childTaskData?.id, childTaskData?.reminder]);

    useEffect(() => {
        const hasMainEmail = Boolean(selectedMail?.Email && Object.keys(selectedMail.Email).length > 0);
        if (
            !hasMainEmail &&
            childTaskData?.reminder &&
            !compose.reminderDate &&
            !compose.reminder &&
            !childReminderApplied
        ) {
            setCompose((prev) => ({
                ...prev,
                reminder: true,
                reminderDate: childTaskData.reminder,
            }));
            setChildReminderApplied(true);
        }
    }, [selectedMail, childTaskData, compose.reminderDate, compose.reminder, childReminderApplied]);

    const getAllLinkedEmail = async () => {
        try {
            const isMailSend = true;
            const urlParams = new URLSearchParams();
            urlParams.append('isMailSend', isMailSend);
            const response = await services.email.Get_The_Linked_Email(urlParams);
            if (response) {
                const allOptions = (response?.data || []).map((email) => ({
                    label: email.email,
                    value: email.id,
                    color: email.colour,
                }));

                const userData = userDataRef.current;
                let options = allOptions;
                if (userData?.role === 'User') {
                    const mapped = userData?.usersEmailMapped;
                    if (Array.isArray(mapped) && mapped.length > 0) {
                        options = allOptions.filter(opt =>
                            mapped.some(m => !m.webmail && (m.value === opt.value || m.label === opt.label))
                        );
                    } else {
                        options = [];
                    }
                }

                setGmailUsers(options);
                setCompose((prev) => {
                    const sentByEmail = selectedMail?.Email?.sentBy?.match(/<([^>]+)>/)?.[1];
                    const sentToEmail = selectedMail?.Email?.sentTo?.match(/<([^>]+)>/)?.[1];
                    const matchedSendTo = options.find((e) => e.label === sentByEmail);
                    const matchedSendBy = options.find((e) => e.label === sentToEmail);

                    let finalEmail = '';
                    let finalSource = '';
                    if (matchedSendTo && matchedSendBy) {
                        finalEmail = matchedSendTo.label;
                        finalSource = 'sendTo';
                    } else if (matchedSendTo) {
                        finalEmail = matchedSendTo.label;
                        finalSource = 'sendTo';
                    } else if (matchedSendBy) {
                        finalEmail = matchedSendBy.label;
                        finalSource = 'sendBy';
                    } else if (options.length > 0) {
                        finalEmail = options[0].label;
                        finalSource = 'default';
                    }
                    return {
                        ...prev,
                        sentBy: prev.sentBy || finalEmail,
                    };
                });
            }
        } catch (error) {
            console.error('error', error);
        }
    };
    const updateDraft = async () => {
        try {
            const formData = new FormData();
            formData.append("draftId", draftId);
            formData.append("sentTo", compose.sentTo);
            formData.append("body", compose.body);
            formData.append("subject", compose.subject);
            formData.append("reminder", compose.reminder ? "true" : "false");
            formData.append("reminderDate", compose.reminderDate ? compose.reminderDate : "");
            formData.append("bcc", compose.bcc || "");
            formData.append("cc", compose.cc || "");

            uploadedFiles.forEach((file) => {
                formData.append("attachments", file);
            });

            // await services.draft.UPDATE_DRAFT(draftId, formData);
            setDraftStatus("Draft Saved");
            setTimeout(() => setDraftStatus(""), 3000);
        } catch (e) {
            console.error("Draft update failed", e);
            setDraftStatus("Failed to update draft");
        }
    };
    const saveDraft = async () => {
        try {
            const formData = new FormData();
            formData.append('parentTaskID', compose.parentTaskID);

            formData.append("sentBy", compose.sentBy);
            formData.append("boardListId", compose.boardListId);
            formData.append("sentTo", compose.sentTo);
            formData.append("body", compose.body);
            formData.append("subject", compose.subject);
            formData.append("reminder", compose.reminder ? "true" : "false");
            formData.append("reminderDate", compose.reminderDate ? compose.reminderDate : "");
            formData.append("boardId", compose.boardId);
            formData.append("bcc", compose.bcc || "");
            formData.append("cc", compose.cc || "");

            uploadedFiles.forEach((file) => {
                formData.append("attachments", file);
            });
            // const res = await services.draft.CREATE_DRAFT(formData);
            setDraftId(res?.data?.data?.id);
            setDraftStatus("Draft saved");
            setTimeout(() => setDraftStatus(""), 3000);
        } catch (e) {
            console.error("Draft create failed", e);
            setDraftStatus("Failed to save draft");
        }
    };

    // useEffect(() => {
    //     if (!compose.sentTo) return;
    //     const delay = setTimeout(() => {
    //         if (draftId) {
    //             updateDraft();
    //         } else {
    //             saveDraft();
    //         }
    //     }, 2000);

    //     return () => clearTimeout(delay);
    // }, [compose]);


    useEffect(() => {
        getAllLinkedEmail();
    }, []);

    const getWebmailAccounts = async () => {
        try {
            const response = await services.imapEmail.LIST();
            let accounts = (response?.data?.data || response?.data || []).map((account) => ({
                label: account.email,
                value: account.id || account._id,
                color: account.colour,
            }));

            const userData = userDataRef.current;
            if (userData?.role === 'User') {
                const mapped = userData?.usersEmailMapped;
                accounts = Array.isArray(mapped) && mapped.length > 0
                    ? accounts.filter(opt =>
                        mapped.some(m => m.webmail && (m.value === opt.value || m.label === opt.label))
                    )
                    : [];
            }
            setWebmailAccounts(accounts);
        } catch (error) {
            console.error('error', error);
        }
    };

    useEffect(() => {
        getWebmailAccounts();
    }, []);

    const fromOptions = mailSource === 'webmail' ? webmailAccounts : gmailUsers;

    const handleMailSourceChange = (source) => {
        if (source === mailSource) return;
        setMailSource(source);
        setCompose((prev) => ({ ...prev, sentBy: '' }));
        setErrors((prev) => ({ ...prev, sentBy: '' }));
    };

    const handleSubmit = async () => {
        const formData = new FormData();
        formData.append('parentTaskID', compose.parentTaskID);
        formData.append('parentTaskStatus', compose.parentTaskStatus);
        formData.append('sentBy', compose.sentBy);
        formData.append('provider', mailSource === 'webmail' ? 'imap' : 'gmail');
        formData.append('boardListId', compose.boardListId);
        formData.append('sentTo', compose.sentTo);
        const cleanHTML = compose.body ? compose.body.replace(/\r\n|\r|\n/g, '') : '';
        formData.append('body', cleanHTML);
        formData.append('subject', compose.subject);
        if (compose.reminder) {
            formData.append('reminderStatus', 'true');
            formData.append('reminder', compose.reminderDate ? compose.reminderDate : '');
        }
        formData.append('boardId', compose.boardId);
        formData.append('bcc', compose.bcc || '');
        formData.append('cc', compose.cc || '');

        uploadedFiles.forEach((file) => {
            formData.append('attachments', file);
        });

        if (Array.isArray(labelIds) && labelIds.length > 0) {
            formData.append('labelId', labelIds.join(','));
        }

        try {
            setIsUploading(true);
            const sendRes = await services.compose.SEND_COMPOSE(formData);
            // await services.draft.DELETE_BY_ID_DRAFT(draftId)
            setComposeStatus(false);
            setLabelname([]);
            if (setLabelIds) setLabelIds([]);
            const queuedMsg = gmailQueuedMessage(sendRes);
            if (queuedMsg) toast.info(queuedMsg, { autoClose: 8000 });
            else toast.success('Compose Email Sent Successfully...');

            getTaskById(taskID);
            setIsSend(true)

        } catch (e) {
            console.error(e);
            toast.error('Failed to send email');
        } finally {
            setIsUploading(false);
        }
    };

    const handleRemoveFile = (index) => {
        setCompose((prev) => ({
            ...prev,
            attachmentPaths: [],
        }));
        setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const MAX_IMAGES = 10;

    const handleFileChange = (e) => {
        if (e.target.files) {
            const newFiles = Array.from(e.target.files);
            if (uploadedFiles.length + newFiles.length > MAX_IMAGES) {
                toast.error(`You can only select up to ${MAX_IMAGES} images.`);
                return;
            }
            setUploadedFiles((prev) => [...prev, ...newFiles]);
        }
    };

    const getTemplate = async () => {
        try {
            const query = new URLSearchParams();
            query.append("falsePagination", true);
            const response = await services.template.GET_ALL_TEMPLATE(query);

            // Get user access info
            let raw = localStorage.getItem("userData");
            let storedData = {};
            try {
                const parsedOnce = JSON.parse(raw);
                storedData = typeof parsedOnce === "string" ? JSON.parse(parsedOnce) : parsedOnce;
            } catch (err) {
                console.error("Parsing error:", err);
            }

            const role = storedData?.role?.toLowerCase();
            const privileges = storedData?.privileges || getEffectivePrivileges(storedData);
            const allowedFolders = privileges?.emailTemplateFolders || [];

            if (response && Array.isArray(response.templates) && response.templates.length > 0) {
                let filteredTemplates = response.templates.filter(item => item.status === true);

                // Filter by folder access if not admin
                if (role !== "admin") {
                    filteredTemplates = filteredTemplates.filter(item =>
                        !item.folderId || allowedFolders.includes(item.folderId)
                    );
                }

                const mappedTemplates = filteredTemplates.map(item => ({
                    label: item.name || '',
                    value: item.id || '',
                    languages: normalizeTemplateLanguages(item) || {},
                    displayValue: (item.body || '').replace(/\n/g, ' ')
                }));
                setAllTemp([{ value: "", label: "Select template", languages: {} }, ...mappedTemplates]);
            } else {
                setAllTemp([]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const getTemplateFolder = async () => {
        try {
            const res = await services.template.GET_ALL_FOLDER();
            const sorted = (res || []).sort(
                (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
            );
            let raw = localStorage.getItem("userData");
            let storedData = {};

            try {
                const parsedOnce = JSON.parse(raw);
                storedData =
                    typeof parsedOnce === "string"
                        ? JSON.parse(parsedOnce)
                        : parsedOnce;
            } catch (err) {
                console.error("Parsing error:", err);
            }

            const role = storedData?.role?.toLowerCase();
            const privileges = storedData?.privileges || getEffectivePrivileges(storedData);
            if (role === "admin") {
                setFolder(sorted);
            } else {
                const allowedFolders = privileges?.emailTemplateFolders || [];
                setFolder(sorted.filter(folder =>
                    folder.name === "Shared with all" || allowedFolders.includes(folder.id)
                ));
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getTemplateFolder();
        getTemplate();
    }, [selectedMail]);

    const isValidEmail = (email) => {
        if (!email) return true;
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };


    const folderOptions = useMemo(() => {
        const options = folder.map((f) => ({
            value: f.id,
            label: f.name,
            Templates: f.Templates || [],
        }));
        return [{ value: "", label: "Select template folder", Templates: [] }, ...options];
    }, [folder]);


    const selectedFolderOption = useMemo(() => {
        return folderOptions.find((f) => f.value === selectedFolder) || null;
    }, [folderOptions, selectedFolder]);

    /* ------------------ TEMPLATE OPTIONS ------------------ */
    const selectedTemplateOption = useMemo(() => {
        return allTemp.find((t) => t.value === templateselect) || null;
    }, [allTemp, templateselect]);

    const getAvailableLanguages = useCallback((languages) =>
        Object.entries(languages)
            .filter(([_, data]) => data.subject.trim() || data.body.trim())
            .map(([lang]) => ({ value: lang, label: lang }))
        , []);
    const normalizeTemplateLanguages = (t) => ({
        English: {
            subject: t.subject || '',
            body: t.body || ''
        },
        French: {
            subject: t.frenchSubject || '',
            body: t.frenchBody || ''
        },
        German: {
            subject: t.germanSubject || '',
            body: t.germanBody || ''
        },
        Portuguese: {
            subject: t.portugueseSubject || '',
            body: t.portugueseBody || ''
        },
        Spanish: {
            subject: t.spanishSubject || '',
            body: t.spanishBody || ''
        }
    });
    const handleFolderChange = (option) => {
        if (!option) return;

        if (option.value === "") {
            getTemplate();
            setSelectedFolder("");
            setTemplateselect("");
            setSelectedLanguage("");
            setAvailableLanguages([]);
            setCompose((prev) => ({
                ...prev,
                subject: "",
                body: "",
            }));
            return;
        }

        const templates =
            option.Templates?.map((t) => ({
                value: t.id,
                label: t.name,
                languages: normalizeTemplateLanguages(t) || {},
            })) || [];

        setSelectedFolder(option.value);
        setTemplateselect("");
        setSelectedLanguage("");
        setAvailableLanguages([]);
        setAllTemp([{ value: "", label: "Select template", languages: {} }, ...templates]);

        setCompose((prev) => ({
            ...prev,
            subject: "",
            body: "",
        }));
    };

    const handleTemplateChange = (option) => {
        if (!option) return;
        setTemplateselect(option.value);

        if (option.value === "") {
            setSelectedLanguage("");
            setAvailableLanguages([]);
            setCompose((prev) => ({
                ...prev,
                subject: "",
                body: "",
            }));
            return;
        }

        const langs = getAvailableLanguages(option.languages);
        setAvailableLanguages(langs);

        const defaultLang = langs.length ? langs[0].value : "";
        setSelectedLanguage(defaultLang);
        setCompose((prev) => ({
            ...prev,
            subject: option.languages?.[defaultLang]?.subject || "",
            body: option.languages?.[defaultLang]?.body || "",
        }));
    };


    const handleLanguageChange = (option) => {
        const lang = option?.value ?? '';
        setSelectedLanguage(lang);

        const template = allTemp.find((t) => t.value === templateselect);
        if (!template) return;

        setCompose((prev) => ({
            ...prev,
            subject: template.languages?.[lang]?.subject || "",
            body: template.languages?.[lang]?.body || "",
        }));
    };

    const languageOptions = useMemo(
        () => [{ value: '', label: 'Select language' }, ...availableLanguages],
        [availableLanguages]
    );

    const selectedLanguageOption = useMemo(() => {
        return languageOptions.find((o) => o.value === selectedLanguage) ?? languageOptions[0] ?? null;
    }, [languageOptions, selectedLanguage]);

    const reminderPresets = [
        { key: 'today', label: 'Later today', icon: '☀️', option: { daysToAdd: 0, time: { hours: 12, minutes: 0 } } },
        { key: 'tomorrow', label: 'Tomorrow', icon: '🌙', option: { daysToAdd: 1, time: { hours: 8, minutes: 0 } } },
        { key: 'twoDays', label: 'In two days', icon: '🕒', option: { daysToAdd: 2, time: { hours: 8, minutes: 0 } } },
        { key: 'nextWeek', label: 'Next week', icon: '📅', option: { daysToAdd: 7, time: { hours: 8, minutes: 0 } } },
    ];

    return (
        <div
            className={`mail-reply-compose compose-email-form replydropdown mailreply-dropbox ${replyDropdown ? 'open' : ''}`}
            style={{ width: '100%' }}
        >
            <div className="mail-reply-compose-card compose-email-card">
                {isUploading ? <Loading /> : (
                    <>
                        <div className="compose-email-heading-row">
                            <h2 className="compose-email-heading">New Message</h2>
                            {draftStatus && (
                                <span className="mail-reply-draft-status">{draftStatus}</span>
                            )}
                        </div>

                        <div className="view-toggle-group compose-email-source-toggle" role="tablist" aria-label="Compose with">
                            <button
                                type="button"
                                role="tab"
                                aria-selected={mailSource === 'gmail'}
                                className={`view-toggle-btn${mailSource === 'gmail' ? ' active' : ''}`}
                                onClick={() => handleMailSourceChange('gmail')}
                            >
                                Gmail
                            </button>
                            {(userDataRef.current?.role !== 'User' || webmailAccounts.length > 0) && <button
                                type="button"
                                role="tab"
                                aria-selected={mailSource === 'webmail'}
                                className={`view-toggle-btn${mailSource === 'webmail' ? ' active' : ''}`}
                                onClick={() => handleMailSourceChange('webmail')}
                            >
                                Webmail
                            </button>}
                        </div>

                        <button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                setLabelAnchorEl(e.currentTarget);
                            }}
                            className="compose-email-label-chip"
                        >
                            {labelname.length > 0 ? labelname.join(', ') : 'Add a label'}
                        </button>

                        <div className="compose-email-field">
                            <label className="mail-reply-field-label">From</label>
                            <Select
                                className={`compose-email-from-select${errors.sentBy ? ' compose-email-input--error' : ''}`}
                                options={fromOptions}
                                values={fromOptions.filter((user) => user.label === compose.sentBy)}
                                onChange={(selectedOption) => {
                                    if (selectedOption.length > 0) {
                                        setCompose((prev) => ({ ...prev, sentBy: selectedOption[0].label }));
                                        setErrors((prev) => ({ ...prev, sentBy: '' }));
                                    }
                                }}
                            />
                            {errors.sentBy && <span style={{ color: 'red', fontSize: '12px' }}>{errors.sentBy}</span>}
                        </div>

                        <div className="compose-email-field">
                            <div className="compose-email-to-row">
                                <label className="mail-reply-field-label">To</label>
                                <div className="compose-email-cc-bcc-links">
                                    {!showCc && (
                                        <span onClick={() => setShowCc(true)} className="mail-reply-cc-bcc-link" role="button" tabIndex={0}>
                                            Cc
                                        </span>
                                    )}
                                    {!showBcc && (
                                        <span onClick={() => setShowBcc(true)} className="mail-reply-cc-bcc-link" role="button" tabIndex={0}>
                                            Bcc
                                        </span>
                                    )}
                                </div>
                            </div>

                            <input
                                id="recipients"
                                placeholder="To"
                                type="email"
                                className={`mail-reply-input block w-full px-3 py-2 text-sm${errors.sentTo ? ' compose-email-input--error' : ''}`}
                                value={compose?.sentTo}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setCompose((prev) => ({ ...prev, sentTo: value }));
                                    setErrors((prev) => ({ ...prev, sentTo: '' }));
                                }}
                            />
                            {errors.sentTo && <span style={{ color: 'red', fontSize: '12px' }}>{errors.sentTo}</span>}

                            {showCc && (
                                <div className="compose-email-extra-field">
                                    <label className="mail-reply-field-label">Cc</label>
                                    <input
                                        type="email"
                                        placeholder="Cc"
                                        className={`mail-reply-input block w-full px-3 py-2 mt-1 text-sm${errors.cc ? ' compose-email-input--error' : ''}`}
                                        value={compose?.cc || ''}
                                        onChange={(e) => {
                                            setCompose((prev) => ({ ...prev, cc: e.target.value }));
                                            setErrors((prev) => ({ ...prev, cc: '' }));
                                        }}
                                    />
                                    {errors.cc && <span style={{ color: 'red', fontSize: '12px' }}>{errors.cc}</span>}
                                </div>
                            )}
                            {showBcc && (
                                <div className="compose-email-extra-field">
                                    <label className="mail-reply-field-label">Bcc</label>
                                    <input
                                        type="email"
                                        placeholder="Bcc"
                                        className={`mail-reply-input block w-full px-3 py-2 mt-1 text-sm${errors.bcc ? ' compose-email-input--error' : ''}`}
                                        value={compose?.bcc || ''}
                                        onChange={(e) => {
                                            setCompose((prev) => ({ ...prev, bcc: e.target.value }));
                                            setErrors((prev) => ({ ...prev, bcc: '' }));
                                        }}
                                    />
                                    {errors.bcc && <span style={{ color: 'red', fontSize: '12px' }}>{errors.bcc}</span>}
                                </div>
                            )}
                        </div>

                        <div className="compose-email-reminder-row">
                            <input
                                id="reminder-checkbox"
                                type="checkbox"
                                checked={compose.reminder || noReminderNeeded}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    if (checked) {
                                        setNoReminderNeeded(false);
                                        setErrors((prev) => ({ ...prev, reminder: '' }));
                                    }
                                    setCompose((prev) => ({ ...prev, reminder: checked, reminderDate: checked ? prev.reminderDate : null }));
                                    if (!checked) {
                                        setNoReminderNeeded(false);
                                        setShowComposeReminderDropdown(false);
                                        setShowReminderDatePicker(false);
                                        setReminderNote('');
                                        setMyDayChecked(true);
                                        setDeadlineChecked(true);
                                    } else {
                                        setShowComposeReminderDropdown(true);
                                    }
                                }}
                                className="reminder-dropdown__checkbox"
                            />
                            <label htmlFor="reminder-checkbox" className="compose-email-reminder-label">
                                Set reminder
                            </label>
                        </div>
                        {errors.reminder && (
                            <span style={{ color: 'red', fontSize: '12px', display: 'block', marginBottom: '4px' }}>
                                {errors.reminder}
                            </span>
                        )}
                        {(compose.reminder || noReminderNeeded) && (
                            <div className="compose-email-reminder-wrap">
                                <button
                                    className="compose-email-reminder-trigger"
                                    type="button"
                                    onClick={() => {
                                        if (noReminderNeeded) {
                                            setNoReminderNeeded(false);
                                            setCompose((prev) => ({ ...prev, reminder: true, reminderDate: null }));
                                            setShowComposeReminderDropdown(true);
                                        } else {
                                            setShowComposeReminderDropdown((prev) => !prev);
                                        }
                                    }}
                                >
                                    <span>
                                        {noReminderNeeded
                                            ? 'No reminder needed'
                                            : compose.reminderDate
                                                ? formatDateForDisplay(compose.reminderDate)
                                                : 'Reminder...'}
                                    </span>
                                    <span className="compose-email-reminder-chevron" aria-hidden="true">▾</span>
                                </button>

                                {showComposeReminderDropdown && (
                                    <div className="reminder-dropdown reminder-dropdown--anchored compose-email-reminder-dropdown">
                                        <div className={`reminder-dropdown__card ${showReminderDatePicker ? 'reminder-dropdown__card--expanded' : ''}`}>
                                            <div className="reminder-dropdown__header">
                                                <span className="reminder-dropdown__title">Reminder...</span>
                                                <button
                                                    type="button"
                                                    onClick={clearReminder}
                                                    className="reminder-dropdown__clear"
                                                >
                                                    Clear
                                                </button>
                                            </div>

                                            <ul className="reminder-dropdown__options">
                                                {reminderPresets.map(({ key, label, icon, option }) => (
                                                    <li key={key}>
                                                        <button
                                                            type="button"
                                                            className="reminder-dropdown__option"
                                                            onClick={() => {
                                                                handleReminderSelection(option);
                                                                setShowComposeReminderDropdown(false);
                                                            }}
                                                        >
                                                            <span className="reminder-dropdown__option-left">
                                                                <span className="reminder-dropdown__option-icon" aria-hidden="true">{icon}</span>
                                                                <span className="reminder-dropdown__option-label">{label}</span>
                                                            </span>
                                                            <span className="reminder-dropdown__option-time">
                                                                {formatDateForDisplay(getFormattedDate(option))}
                                                            </span>
                                                        </button>
                                                    </li>
                                                ))}
                                                <li className={showReminderDatePicker ? 'reminder-dropdown__pick-row--open' : ''}>
                                                    <button
                                                        type="button"
                                                        className={`reminder-dropdown__option ${showReminderDatePicker ? 'reminder-dropdown__option--active' : ''}`}
                                                        onClick={() => setShowReminderDatePicker((prev) => !prev)}
                                                        aria-expanded={showReminderDatePicker}
                                                    >
                                                        <span className="reminder-dropdown__option-left">
                                                            <span className="reminder-dropdown__option-icon" aria-hidden="true">📆</span>
                                                            <span className="reminder-dropdown__option-label">Pick a date</span>
                                                        </span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        className="reminder-dropdown__option"
                                                        onClick={() => {
                                                            setNoReminderNeeded(true);
                                                            setCompose((prev) => ({ ...prev, reminder: false, reminderDate: null }));
                                                            setShowComposeReminderDropdown(false);
                                                            setShowReminderDatePicker(false);
                                                            setErrors((prev) => ({ ...prev, reminder: '' }));
                                                        }}
                                                    >
                                                        <span className="reminder-dropdown__option-left">
                                                            <span className="reminder-dropdown__option-icon" aria-hidden="true">🚫</span>
                                                            <span className="reminder-dropdown__option-label">No reminder needed</span>
                                                        </span>
                                                    </button>
                                                </li>
                                            </ul>

                                            {showReminderDatePicker && (
                                                <div className="reminder-dropdown__datepicker">
                                                    <DatePicker
                                                        calendarClassName="reminder-dropdown__calendar"
                                                        wrapperClassName="reminder-dropdown__datepicker-wrapper"
                                                        selected={compose.reminderDate ? new Date(compose.reminderDate) : null}
                                                        onChange={(date) => {
                                                            setCompose((prev) => ({ ...prev, reminder: true, reminderDate: date?.toISOString() }));
                                                            setShowReminderDatePicker(false);
                                                            setShowComposeReminderDropdown(false);
                                                        }}
                                                        inline
                                                        showTimeSelect
                                                        minDate={new Date()}
                                                        timeFormat="hh:mm aa"
                                                        timeIntervals={15}
                                                        dateFormat="MMMM d, yyyy h:mm aa"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="mail-reply-template-panel">
                            <div className="compose-email-template-grid">
                                <div className="compose-email-template-col">
                                    <label className="mail-reply-field-label">Select Template Folder</label>
                                    <Dropdown
                                        styles={mailReplySelectStyles}
                                        classNamePrefix="mail-reply-select"
                                        value={selectedFolderOption}
                                        options={folderOptions}
                                        className="mail-reply-react-select block text-sm"
                                        placeholder="Search folder..."
                                        onChange={handleFolderChange}
                                    />
                                </div>
                                <div className="compose-email-template-col">
                                    <label className="mail-reply-field-label">Template</label>
                                    <Dropdown
                                        styles={mailReplySelectStyles}
                                        classNamePrefix="mail-reply-select"
                                        className="mail-reply-react-select w-full text-sm"
                                        value={selectedTemplateOption}
                                        options={allTemp}
                                        placeholder="Search template..."
                                        disabled={!selectedFolder}
                                        onChange={handleTemplateChange}
                                    />
                                </div>
                                <div className="compose-email-template-col">
                                    <label className="mail-reply-field-label">Language</label>
                                    <Dropdown
                                        styles={mailReplySelectStyles}
                                        classNamePrefix="mail-reply-select"
                                        className="mail-reply-react-select w-full text-sm"
                                        value={selectedLanguageOption}
                                        options={languageOptions}
                                        placeholder="Select language"
                                        isDisabled={!templateselect}
                                        onChange={handleLanguageChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="compose-email-field">
                            <label className="mail-reply-field-label">Subject</label>
                            <input
                                id="subject"
                                placeholder="Subject"
                                type="text"
                                className={`mail-reply-input block w-full px-3 py-2 text-sm${errors.subject ? ' compose-email-input--error' : ''}`}
                                value={compose?.subject}
                                onChange={(e) => {
                                    setCompose((prev) => ({ ...prev, subject: e.target.value }));
                                    setErrors((prev) => ({ ...prev, subject: '' }));
                                }}
                            />
                            {errors.subject && <span style={{ color: 'red', fontSize: '12px' }}>{errors.subject}</span>}
                        </div>

                        <div className="compose-email-field mail-reply-editor-wrap">
                            <label className="mail-reply-field-label">Message</label>
                            <EditorComponent
                                key={editorKey}
                                value={compose?.body}
                                selectedPrevData={memoizedPrevData}
                                handleEditorChange={memoizedHandleEditorChange}
                                allTemp={allTemp}
                                selectedLanguage={selectedLanguage}
                                onSubjectChange={(subject) => setCompose((prev) => ({ ...prev, subject }))}
                            />
                            {errors.body && <span style={{ color: 'red', fontSize: '12px' }}>{errors.body}</span>}
                        </div>

                        {uploadedFiles.length > 0 && (
                            <div className="mail-reply-attachments-panel mb-4">
                                <div className="flex flex-wrap gap-4">
                                    {uploadedFiles.map((file, idx) =>
                                        file.type.startsWith('image/') ? (
                                            <div className="email-file-preview" key={idx}>
                                                <img
                                                    src={URL.createObjectURL(file)}
                                                    alt={`Preview ${idx}`}
                                                    className="rounded-md w-24 h-24 object-cover shadow"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveFile(idx)}
                                                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                                    title="Remove"
                                                >
                                                    &times;
                                                </button>
                                            </div>
                                        ) : (
                                            <div key={idx} className="email-file-preview flex items-center gap-2 bg-white rounded px-2 py-1 shadow">
                                                <span>{file.name}</span>
                                                {file.type === 'application/pdf' && <span className="text-xs text-gray-500">(PDF)</span>}
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveFile(idx)}
                                                    className="bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                                    title="Remove"
                                                >
                                                    &times;
                                                </button>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="mail-reply-footer flex items-center justify-between w-full pt-4 border-t">
                            <div className="flex items-center gap-3">
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (!labelname || labelname.length === 0) {
                                            toast.error('Please add a label before sending.');
                                            return;
                                        }
                                        const newErrors = validate(noReminderNeeded);
                                        if (Object.keys(newErrors).length > 0) {
                                            setErrors(newErrors);
                                            return;
                                        }
                                        setErrors({});
                                        setShowConfirmation(true);
                                    }}
                                    className="mail-reply-send-btn"
                                >
                                    {isUploading ? 'Sending...' : 'Send'}
                                </button>

                                <label
                                    data-tooltip-id="upload-tooltip"
                                    data-tooltip-content="Attach files"
                                    className="mail-reply-attach-btn cursor-pointer"
                                >
                                    <input
                                        type="file"
                                        accept="image/*,application/pdf"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                    />
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        viewBox="0 0 16 16"
                                        aria-hidden="true"
                                    >
                                        <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                                    </svg>
                                </label>

                                <Tooltip id="upload-tooltip" place="top" style={{ fontSize: '12px', marginBottom: '5px' }} />
                            </div>

                            <button type="button" onClick={handleDelete} className="mail-reply-delete-btn" aria-label="Discard draft">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                    aria-hidden="true"
                                >
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 5h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7H6v7a.5.5 0 0 1-1 0v-7z" />
                                    <path
                                        fillRule="evenodd"
                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1 0-2H5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3a.5.5 0 0 0-.5.5V4h12v-.5a.5.5 0 0 0-.5-.5h-11z"
                                    />
                                </svg>
                            </button>
                        </div>
                    </>
                )}
            </div>
            <Confirmation
                show={showConfirmation}
                onHide={() => setShowConfirmation(false)}
                handleYes={handleSubmit}
                title="Send Mail"
                body="Are you sure you want to send this mail?"
            />
        </div>
    );
};

export default ComposeEmail;
